'use strict';

class labelService {
  constructor($http) {
    this.$http = $http;
  }

  list() {
    return this.$http.get(`/recipients/labels`);
  }

  get(number) {
    return this.$http.get(`/recipients/labels/${number}`);
  }

  create(name) {
    return this.$http.post(`/recipients/labels`, {
      name: name
    });
  }

  remove(number) {
    return this.$http.delete(`/recipients/labels/${number}`);
  }

  // MEMBERS
  members(number) {
    return this.$http.get(`/recipients/labels/${number}/members`);
  }

  assignMember(number, recipientNumber) {
    return this.$http.put(`/recipients/${recipientNumber}/labels/${number}/assign`);
  }

  removeMember(number, recipientNumber) {
    return this.$http.put(`/recipients/${recipientNumber}/labels/${number}/remove`);
  }
}

labelService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('labelService', labelService);
